import { css } from '@/styled-system/css';

export const userItemsTitleBar = css({
  paddingTop: '12px',
  paddingRight: '0',
  paddingBottom: '12px',
  paddingLeft: '0',
  fontSize: 'lg',
  fontWeight: 'bold',
  lineHeight: 'lg',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderColor: 'hpxGrey100',
});
